import { Component, HostBinding, Inject, OnInit } from "@angular/core";

import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { APP_CONFIG, AppConfig, AppParentService } from "./core";
import { AppStateService, AvailabilityState } from "./app-state";

import { filter, tap } from "rxjs";
import { ChatLifecycleService, ChatOpenStore } from "./chat";
import { DimeloStateStore } from "./dimelo";
import { ReducedBotComponent } from "./reduced-bot/reduced-bot-component";
import { ChatBoxComponent } from "./chat/box/chat-box-component";
import { NgIf, NgClass, AsyncPipe } from "@angular/common";
import { HeaderComponent } from "./header/header-component";
import { HeaderBannerComponent } from "./header/header-banner-component";

/** The main component of the application */
@Component({
  selector: "bot-root",
  templateUrl: "./app.component.html",
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    AsyncPipe,
    HeaderComponent,
    HeaderBannerComponent,
    ChatBoxComponent,
    ReducedBotComponent,
  ],
})
export class AppComponent implements OnInit {
  @HostBinding("class") hostClasses: string;

  // TODO test
  constructor(
    @Inject(APP_CONFIG) appConfig: AppConfig,
    private parentService: AppParentService,
    private dimeloStateStore: DimeloStateStore,
    protected appStateService: AppStateService,
    protected chatOpenStore: ChatOpenStore,
    protected chatLifecycleService: ChatLifecycleService
  ) {
    this.hostClasses = `pby-bot-app pby-bot-${appConfig.botName}`;
    this.appStateService.available$
      .pipe(
        filter((available: AvailabilityState) => available === "no"),
        tap(() => this.parentService.removeBot()),
        takeUntilDestroyed()
      )
      .subscribe();
  }

  // TODO test
  ngOnInit() {
    if (this.dimeloStateStore.isDimeloChatDisplayed) {
      this.chatLifecycleService.notifySwitchedOff();
    }
    this.appStateService.initialize();
  }
}
